import * as React from 'react';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';

import CcmCampaignEditModal from 'modules/campaigns/components/ccm/components/modals/edit/CcmCampaignEditModal';
import CcmCampaignDetailsOverviewCampaign from './campaign/CcmCampaignDetailsOverviewCampaign';
import CcmCampaignDetailsOverviewBudget from './budget/CcmCampaignDetailsOverviewBudget';

import {
  fetchCampaignOutfits
} from 'modules/product-list/reducers/campaign-outfits/campaign-outfits';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import './ccm-campaign-details-overview.scss';

applyTranslations(require('./ccm-campaign-details-overview.i18n.json'));

import type { Campaign } from 'types';

type OwnProps = {
  campaign: Campaign
};

type StateProps = {
  canEdit: boolean,
  currentOrganizationId: number
}

type DispatchProps = {
  onMount: (campaignId: number) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const MSG_KEY = 'ccm_campaign_details_overview';

const ActionButtonWithEditModal = withModal(ActionButton, {
  modalContent: CcmCampaignEditModal
});

const CcmCampaignDetailsOverviewCreatorless: React.FC<Props> = ({
  campaign,
  canEdit,
  currentOrganizationId,
  onMount
}): JSX.Element => {
  React.useEffect(() => {
    if (campaign.id === null) {
      return;
    }

    onMount(campaign.id);
  }, [campaign.id]);

  return (
    <div className="ccm-campaign-details-overview">
      <div className="ccm-campaign-details-overview__image ccm-campaign-details-overview__image--creatorless">
        {campaign.name[0]}
      </div>
      <div className="ccm-campaign-details-overview__info">
        <CcmCampaignDetailsOverviewCampaign
          campaign={campaign}
          isCampaignCreatorless
        />
        <CcmCampaignDetailsOverviewBudget
          campaign={campaign}
          isCampaignCreatorless
        />
        {
          !isNil(campaign.dataLastUpdated) && (
            <div className="ccm-campaign-details-overview__data-updated">
              {__t(`${MSG_KEY}.data_last_updated`)}: {getDisplayDate(campaign.dataLastUpdated)}
            </div>
          )
        }
        {canEdit ? (
          <ActionButtonWithEditModal
            modalContentProps={{
              campaignId: campaign.id,
              campaignType: campaign?.campaignType,
              organizationId: currentOrganizationId,
              brandProfileId: campaign?.brandProfile?.id ?? -1,
              hideNotes: true
            }}
          >
            {__t(`${MSG_KEY}.edit_button`)}
          </ActionButtonWithEditModal>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  campaignOutfits,
  organizations
}): StateProps => ({
  canEdit: (campaignOutfits.outfits ?? [])
    .every(o => ['draft', 'pending', 'declined'].includes(o.status)),
  currentOrganizationId: organizations.currentOrganizationId
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  onMount: campaignId => dispatch(fetchCampaignOutfits(campaignId, 'ccm_creatorless'))
});

export default connect(mapStateToProps, mapDispatchToProps)(CcmCampaignDetailsOverviewCreatorless);
